import { render, staticRenderFns } from "./DeletableFilterWrapper.vue?vue&type=template&id=2440dc8e&scoped=true"
import script from "./DeletableFilterWrapper.vue?vue&type=script&lang=js"
export * from "./DeletableFilterWrapper.vue?vue&type=script&lang=js"
import style0 from "./DeletableFilterWrapper.vue?vue&type=style&index=0&id=2440dc8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2440dc8e",
  null
  
)

export default component.exports